import React from "react";
import moment from "moment";
import {appConf} from "../../../Setup/appConfig/app.config";
import {DescriptionPanel} from "../../../AppCore/Component/Panel";

export const AgreementDescription = ({commissionRate, partnerLegalName}) => {
  return (
    <DescriptionPanel title={"PARTNER AGREEMENT"}>
      <p>
        This Limited Agency Agreement or Partner Agreement (the "Agreement") is made by and
        between GRNLK Corp (DBA "GreenLink Networks") and the following entity, <u>{partnerLegalName}</u> ("Partner"),
        to be effective as of <u>{moment().format(appConf.dateDefaultFormat)}</u> (the "Effective Date").
      </p>
      <p>
        GreenLink Networks owns and/or operates Voice over Internet Protocol ("VoIP") telecommunications systems that
        provide audio communications solutions ("Services") and VoIP-related products ("Products") to its customers (the
        "End User(s)"). GreenLink and Partner desire to enter into a non-exclusive agreement whereby Partner will
        market, promote and sell GreenLink Services and Products to existing, new and potential customers under the
        terms and conditions set forth in the terms and conditions found at {" "}
        <a
          href="https://www.greenlinknetworks.com/partner/partner-legal"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.greenlinknetworks.com/partner/partner-legal
        </a> ("Terms and Conditions"), which are hereby incorporated into this Agreement.
      </p>

      <p>
        Therefore, in consideration of the promises and the mutual covenants between them, the parties agree to the
        terms of the Partner Program and the Commission and Bonus Plan described in detail in the Terms and Conditions
        and agree to a starting {" "}<u>commission rate of {commissionRate}%</u>{" "} for each dollar of revenue
        collected and a bonus of $500 for
        every 25 seats (extensions/SIP trunks) sold.
      </p>

      <p>
        In order for Partner to be eligible to earn commissions and bonuses, an End User Agreement must be signed by the
        End User and Services must be "live" for one month. For the purposes of this Agreement, "live" means the time at
        which (1) GreenLink has deemed Services and Products to be installed; (2) monthly billing has commenced; and (3)
        the first invoice has been paid in full to GreenLink. All commissions and bonuses are calculated based on paid
        invoices.
      </p>

      <p>
        IN  WITNESS  WHEREOF,  the  parties  have  executed  and  delivered  this  Agreement  as  of  the Effective Date.
      </p>
    </DescriptionPanel>
  );
};



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Component/Agreement/AgreementDescription.js